import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertUilmTranslationJobMutation, InsertUilmTranslationJobMutationVariables } from '@/graphql/generated/graphql';
import { InsertUilmTranslationJobDocument } from '@/graphql/generated/graphql';
export type UilmTranslationJobInsertInput = {
  OrganizationIds?: string[]
  MessageCoRelationId?: string
  TemplateId?: string
  TemplateSlug?: string
  ModuleId?: string
  DefaultLanguage?: string
  Status?: string
  StartedAt?: string
  CompletedAt?: string
  ErrorMessage?: string
}

export type InsertUilmTranslationJobResponse = {
  data: {
    insertUilmTranslationJob: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertUilmTranslationJob = () => {
  const mutation = useMutation({
    mutationKey: ['insert-uilm-translation-job'],
    mutationFn: (variables: UilmTranslationJobInsertInput) => {
      return graphqlClient.request<InsertUilmTranslationJobMutation>(InsertUilmTranslationJobDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertUilmTranslationJob: mutation.mutate,
    insertUilmTranslationJobAsync: mutation.mutateAsync,
  }
}

export const INSERT_UILM_TRANSLATION_JOB_MUTATION = InsertUilmTranslationJobDocument;
